import { useEffect } from "react";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter, useLocation } from "react-router-dom";

import { store } from "./redux/store";
import AppRoutes from "./App.routes";
import ErrorBoundary from "./utils/error-boundary/ErrorBoundary.component";
import Message from "./utils/message/Message.component";

const preloadRouteForPath = (pathname: string) => {
  if (pathname.startsWith("/shipping/account-information")) {
    void import("./account-information/account.routes");
    return;
  }

  if (pathname.startsWith("/shipping/account-status")) {
    void import("./account-status/account-status.routes");
    return;
  }

  if (pathname.startsWith("/shipping/onboarding")) {
    void import("./onboarding/onboarding.routes");
  }
};

const RouteChunkPreloader = () => {
  const location = useLocation();

  useEffect(() => {
    preloadRouteForPath(location.pathname);
  }, [location.pathname]);

  return null;
};

export default function App() {
  return (
    <PolarisProvider i18n={{}}>
      <ReduxProvider store={store}>
        <BrowserRouter>
          <RouteChunkPreloader />
          <ErrorBoundary>
            <AppRoutes />

            {/* ===================== App Messages ===================== */}
            <div
              style={{
                position: "fixed",
                bottom: 20,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                zIndex: 999,
              }}
            >
              <div style={{ width: "600px" }}>
                <Message />
              </div>
            </div>
            {/* ===================== App Messages ===================== */}
          </ErrorBoundary>
        </BrowserRouter>
      </ReduxProvider>
    </PolarisProvider>
  );
}
